document.querySelectorAll('#nav-trigger').forEach(item => {
    item.addEventListener('click', event => {
        event.preventDefault();
        document.querySelector('body').classList.toggle("nav-active");
    });
});


const offset = 30;
const bodyElement = document.querySelector('body');

var lastScrollTop = 0;

window.addEventListener('scroll', () => {
    let currentOffset = window.pageYOffset || document.documentElement.scrollTop;

    if (currentOffset > offset) {
        bodyElement.classList.add('scrolled');
    } else {
        bodyElement.classList.remove('scrolled');
    }

    if (currentOffset > lastScrollTop) {
        jQuery('#header').addClass('dir-bottom');
    } else {
        jQuery('#header').removeClass('dir-bottom');
    }
    lastScrollTop = currentOffset <= 0 ? 0 : currentOffset;

}, false);


jQuery('.language-switcher .dropdown-toggle').on('click', function () {
    jQuery(this).closest('.language-switcher').toggleClass('active');
});
